import { Component, Input } from '@angular/core';
import { ProvidersService } from 'fccore2';
import { FcinputComponent } from '../fcinput';
/** çº§èéæ©ææªå¼å */
@Component({
    selector: 'fc-cascader',
    /**
     * @ignore
     */
    template: `
    
    `,
    styles: [`
    :host ::ng-deep .ant-cascader-picker {
        width: 300px;
    }
    .change-options {
        display: inline-block;
        font-size: 12px;
        margin-top: 8px;
    }
    `]
})
export class FccascaderComponent extends FcinputComponent {
    constructor(public provider: ProvidersService) {
        super(provider, 'fc-cascader');
    }
    
}

